import React from "react";

import Info from "./Info";

const DropDown = ({
  value,
  onChange,
  options,
  label,
  includeBlank,
  renderInfo = null,
}) => (
  <div className="question-container">
    <label className="question" htmlFor={label}>
      {label}
    </label>
    {renderInfo && <Info renderContent={renderInfo} />}
    <div className="dropdown-wrapper">
      <select onChange={onChange} value={value}>
        {includeBlank && <option value="" disabled>Bitte wählen</option>}
        {options.map(option => (
          <option key={option.key} value={option.key}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  </div>
);

export default DropDown;
